import { render, staticRenderFns } from "./TextOneColumn.vue?vue&type=template&id=485c62e0&"
import script from "./TextOneColumn.vue?vue&type=script&lang=js&"
export * from "./TextOneColumn.vue?vue&type=script&lang=js&"
import style0 from "./TextOneColumn.vue?vue&type=style&index=0&id=485c62e0&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports